function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { Checkbox } from 'reakit/Checkbox';
import { OwnUpIcon } from '../../../components/images';
import { buildClassNames } from '../../../modules/css-helpers';
import { addVariant } from '../../../modules/variant-helpers';
import { colors } from '../../../theme';
import { createOwnUpComponent } from '../../components';
import { OwnUpCheckboxButtonIndicatorStyle, OwnUpCheckboxDisplayStyle, OwnUpCheckboxStyle, OwnUpCheckboxWrapperStyle } from './style';
/**
 * Checkbox component properties.
 */

var OwnUpCheckboxWrapper = createOwnUpComponent('label', OwnUpCheckboxWrapperStyle);
var StyledCheckboxButtonIndicator = createOwnUpComponent('span', OwnUpCheckboxButtonIndicatorStyle);

var OwnUpCheckboxButtonIndicator = function OwnUpCheckboxButtonIndicator(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var builtClass = useMemo(function () {
    return buildClassNames('ou-checkbox__indicator', className);
  }, [className]);
  return /*#__PURE__*/React.createElement(StyledCheckboxButtonIndicator, _extends({
    className: builtClass
  }, props));
};

var StyledCheckboxButton = createOwnUpComponent(Checkbox, OwnUpCheckboxStyle);
var StyledCheckboxText = createOwnUpComponent('span', OwnUpCheckboxDisplayStyle);

var OwnUpCheckboxText = function OwnUpCheckboxText(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  var builtClass = useMemo(function () {
    return buildClassNames('ou-checkbox__text', className);
  }, [className]);
  return /*#__PURE__*/React.createElement(StyledCheckboxText, _extends({
    className: builtClass
  }, props));
};

export var OwnUpCheckboxImpl = function OwnUpCheckboxImpl(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["className"]);

  var builtClass = useMemo(function () {
    return buildClassNames('ou-checkbox__button', className);
  }, [className]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OwnUpCheckboxButtonIndicator, props, /*#__PURE__*/React.createElement(OwnUpIcon, {
    icon: "CheckMark",
    color: colors.WHITE,
    strokeWidth: "2px",
    height: "14px",
    width: "14px"
  })), /*#__PURE__*/React.createElement(StyledCheckboxButton, _extends({
    className: builtClass
  }, props)));
};
/**
 * Checkbox Component
 *
 * @param props - Seet {@link OwnUpCheckboxProperties}
 */
// Note: due to parser limitations, generic function args in TSX
//   files cannot use arrows.

export function OwnUpCheckbox(_ref4) {
  var className = _ref4.className,
      wrapperClassName = _ref4.wrapperClassName,
      _ref4$checked = _ref4.checked,
      checked = _ref4$checked === void 0 ? false : _ref4$checked,
      variant = _ref4.variant,
      disabled = _ref4.disabled,
      onChange = _ref4.onChange,
      children = _ref4.children,
      _ref4$value = _ref4.value,
      value = _ref4$value === void 0 ? children : _ref4$value,
      optionExpansion = _ref4.optionExpansion,
      props = _objectWithoutProperties(_ref4, ["className", "wrapperClassName", "checked", "variant", "disabled", "onChange", "children", "value", "optionExpansion"]);

  var miniProps = {
    className: className,
    variant: variant
  }; // Class name

  var builtWrapperClass = useMemo(function () {
    return buildClassNames('ou-checkbox__wrapper', wrapperClassName);
  }, [wrapperClassName]);
  var builtClass = useMemo(function () {
    return buildClassNames('ou-checkbox', className);
  }, [className]);
  /**
   * Wrap the onChange function
   */

  var toggleFunction = useCallback(function () {
    if (onChange) {
      onChange({
        value: value,
        checked: !checked
      });
    }
  }, [checked, onChange, value]);

  if (checked) {
    miniProps.variant = addVariant(miniProps.variant, 'checked');
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OwnUpCheckboxWrapper, _extends({
    disabled: disabled
  }, props, miniProps, {
    className: builtWrapperClass
  }), /*#__PURE__*/React.createElement(OwnUpCheckboxImpl, _extends({
    className: builtClass,
    checked: checked,
    onChange: toggleFunction,
    disabled: disabled
  }, miniProps)), /*#__PURE__*/React.createElement(OwnUpCheckboxText, miniProps, children)), checked && optionExpansion ? optionExpansion : null);
}